import { useTranslation, TFunction } from 'react-i18next';
import { KizenTypography } from '__app/typography';
import {
  useAutomationsDispatch,
  useAutomationsSelector,
} from 'pages/AutomationEngine/store/react';
import { actions } from 'pages/AutomationEngine/store';
import { VariableCard } from '__pages/AutomationEngine/Engine/Steps/type/variable/VariableCard';
import { getHistoryId } from 'pages/AutomationEngine/store/selectors';
import { Step } from 'pages/AutomationEngine/types/automation';

export const content = ({ t }: { t: TFunction }) => {
  return t('Add Trigger');
};

type CardProps = {
  type: 'initialize_variable';
  step: Step;
};

export default function VariableIntializionAddCard({
  type,
  step,
  ...others
}: CardProps) {
  const { t } = useTranslation();
  const dispatch = useAutomationsDispatch();
  const historyId = useAutomationsSelector(getHistoryId);
  return (
    <VariableCard
      {...others}
      addMenu={false} // never show a menu
      onClick={() =>
        historyId ? null : dispatch(actions.dropVariableDefinition())
      }
      cardComponentType={historyId ? '' : 'anchor'}
    >
      <KizenTypography
        data-qa="add-variable-btn"
        as="span"
        className={historyId ? '' : 'button-text'}
      >
        {t('Click to add new variable')}
      </KizenTypography>
    </VariableCard>
  );
}
